import validateSearchFilter from './validateSearchFilter';

const search = ({query, searchFilter, list}) => {
  if (_isInvalidList(list)) {
    return [];
  }

  let foundList = list.slice();

  if (_shouldFilterOnFrontEnd(searchFilter)) {
    foundList = _searchItems(query, searchFilter, list);
  }

  return foundList;
};

const _isInvalidList = list => (
  Boolean(!list || !Array.isArray(list) || !list.length)
);

const _shouldFilterOnFrontEnd = searchFilter => (
  validateSearchFilter.validateType(searchFilter)
);

const _searchItems = (query, searchFilter, list) => {
  const foundList = [];
  if (list && Array.isArray(list)) {
    list.forEach(item => {
      const foundListItem = searchFilter(query, item, list);
      if (foundListItem) {
        foundList.push(foundListItem);
      }
    });
  }
  return foundList;
};

export default {
  search
};